
export default function Line ()
{
    return (<hr className="m-0 p-0"/>);
}
